import classNames from 'classnames';
function mergeStyle(style, newStyle) {
    if (!style) {
        return newStyle;
    }
    if (newStyle) {
        return {
            ...style,
            ...newStyle,
        };
    }
    return style;
}
function mergeClassNameAndStyle(props, newProps) {
    if (!props) {
        return newProps;
    }
    if (newProps) {
        const style = mergeStyle(props.style, newProps.style);
        const className = classNames(props.className, newProps.className);
        if (style || className) {
            return {
                style,
                className,
            };
        }
        return undefined;
    }
    return props;
}
export default function mergeProps(props, newProps) {
    if (!props) {
        return newProps;
    }
    if (newProps) {
        return {
            ...props,
            ...newProps,
            ...mergeClassNameAndStyle(props, newProps),
        };
    }
    return props;
}
